import createElementChangeListener from '../../elementChangeListener';

const userBehaviorClass = 'rm_user_behavior_content';
const loadedClass = 'loaded'; 
const elementsLoaded = new Set(); 

let page = 1;

async function fetchContent(url) {
    page++;
    const response = await fetch(url);
    return response.json();
}

function extractIds(data) {
    const dataArray = JSON.parse(data);
    if (Array.isArray(dataArray)) {
        return dataArray.map(item => item.id);
    }
    return [];
}

function getUserHistory() {
    const userId = localStorage.getItem("userTrackingId");
    const userHistory = localStorage.getItem(`history-${userId}`);
    const userPostIds = extractIds(userHistory);

    return userPostIds;
}

async function getUserBehaviorContent(element) {
    const url = buildUserBehaviorPageUrl(element);
    const response = await fetchContent(url);
    const content = response.html;

    if (element) {
        element.innerHTML = content;
        element.classList.add(loadedClass);
        elementsLoaded.add(element);
    }
}

function makeUserBehaviorParams(element) {
    const postIds = getUserHistory();
    const weights = Array(postIds.length).fill(1);
    const layoutName = element.getAttribute('data-attr-layout-name');

    return {
        resource_id: "generic",
        post_ids_list: postIds,
        layout_name: layoutName,
        weights,
        page,
    };
}

function buildUserBehaviorPageUrl(element) {
    const baseUrl = "/res/custom_page/data.js";
    const params = makeUserBehaviorParams(element);

    return appendQueryParams([baseUrl, params]);
}

function appendQueryParams([url, params]) {
    return `${url}?${new URLSearchParams(params).toString()}`;
}

function monitorNewElements(element){
    createElementChangeListener(element, (contentPlaceholder) => {
        if (!elementsLoaded.has(contentPlaceholder)) {
            getUserBehaviorContent(contentPlaceholder);
        }
    })
}

monitorNewElements(`.${userBehaviorClass}:not(.${loadedClass})`);